<!--左部菜单切换栏-->
<template>
  <div class="section-left" :style="{'marginTop':marginTop + 'px','height':height}">
    <el-scrollbar ref="scrollbar" class="section-left__scroll">
      <el-menu
        class="el-menu-vertical-demo left_menu"
        :default-active="activeNow"
        :default-openeds="openeds"
        text-color="#666666"
        active-text-color="#3159FF"
      >
        <div v-for="(item, ind) in getMenu" :key="ind">
          <el-menu-item
            v-if="item.path == '/home' || (item.path == '/hdHome' && softType == 1)"
            :index="item.jumpUrl"
            @click.native.stop.prevent="routerpush(item)"
          >
            <div class="title-wrap">
              <template>
                <img class="title-wrap-img" v-if="activeNow == item.path" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/home_c.svg" alt="">
                <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/home.svg" alt="">
              </template>
              <span :class="activeFirstMenu==item.path?'textElse act':'textElse'">{{item.tittle}}</span>
            </div> 
          </el-menu-item>
          <el-submenu v-else :index="item.jumpUrl" class="left-nav-color">
            <template slot="title">
              <div class="title-wrap">
                <template v-if="item.path == '/manage'">
                  <img class="title-wrap-img" v-if="getIcon(item.children)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/use_c.svg" alt="">
                  <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/use.svg" alt="">
                </template>
                <template v-if="item.path == '/orderCare'">
                  <img class="title-wrap-img" v-if="getIcon(item.children)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/list_c.svg" alt="">
                  <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/list.svg" alt="">
                </template>
                <template v-if="item.path == '/backstage'">
                  <img class="title-wrap-img" v-if="getIcon(item.children)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/system_c.svg" alt="">
                  <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/system.svg" alt="">
                </template>
                <template v-if="item.path == '/member'">
                  <img class="title-wrap-img" v-if="getIcon(item.children)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/member_c.svg" alt="">
                  <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/member.svg" alt="">
                </template>
                <template v-if="item.path == '/customerOperationPlatform' || item.path == '/marketing'">
                  <img class="title-wrap-img" v-if="getIcon(item.children)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/data_c.svg" alt="">
                  <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/data.svg" alt="">
                </template>
                <template v-if="item.path == '/analysis'">
                  <img class="title-wrap-img" v-if="getIcon(item.children)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/chart_c.svg" alt="">
                  <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/chart.svg" alt="">
                </template>
                <template v-if="item.path == '/interactiveMarketing'">
                  <img class="title-wrap-img" v-if="getIcon(item.children)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/change_c.svg" alt="">
                  <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/change.svg" alt="">
                </template>
                <template v-if="item.path == '/tool'">
                  <img class="title-wrap-img" v-if="getIcon(item.children)" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/tool_c.svg" alt="">
                  <img class="title-wrap-img" v-else src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/tool.svg" alt="">
                </template>
                <span  :class="activeFirstMenu==item.path?'title-wrap-text act':'title-wrap-text'">{{item.tittle}}</span>
              </div>
            </template>
            <template v-if="item.children && item.children.length !== 0">
              <el-menu-item
                :index="child.path == 'grouping' ? undefined : child.jumpUrl"
                @click.native.stop.prevent="routerpush(child,item)"
                v-for="(child, index) in item.children"
                :key="index"
                style="position: relative;"
                >
                <span :class="activeNow.endsWith(child.path)?'sub_title act':'sub_title'">
                  <img height="14px" style="z-index: 10;" v-if="child.path=='bi'|| child.path=='yunqi_bi' || child.path=='bi_preview'" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menuNew/bi.svg" alt="">
                  <span v-if="child.path != 'zhipuDecoration'">{{ child.tittle }}</span>
                  <span v-else>店铺装修</span>
                </span>
                <img class="personManager" v-if="child.tittle=='人群管理'" src="@/assets/homeDemo/jd.svg" alt="">
                <img v-if="child.tittle == '商品复购'" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tag_hot.svg" style="margin-left: 1px;" />
                <img v-if="child.tittle == '专享客服'" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tag_new.svg" style="margin-left: 1px;margin-top:-4px;" />
                <img v-if="child.tittle == '积分竞拍'" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tag_new.svg" style="margin-left: -5px;margin-top:-4px;width:25px;" />
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tag_gaoji.svg" style="width:50px" v-if="child.isShowTrialMark == 1" />
                <div class="nav-zhipu-tip3 flex-cen-xy" v-if="child.path == 'zhipuDecoration'"></div>
                <div class="nav-zhipu-tip1 flex-cen-xy" v-if="child.path == 'widget'"></div>
                <div class="nav-zhipu-tip2 flex-cen-xy" v-if="child.path == 'dongdong_marketing_model'"></div>
                <!-- 京东人群显示右上角图标 -->
                <!-- <img v-if="child.path == 'crowd_management'" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/menu/jingdong.png" class="jd-icon"> -->
              </el-menu-item>
            </template>
          </el-submenu>
        </div>
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  name: "left-select",
  props: {
    marginTop:{
      type:Number,
      default:0
    },
    height:{
      type:String,
    }
  },
  data() {
    return {
      activeNow: "", //当前激活的菜单
      activeFirstMenu: "", //当前激活的菜单的一级菜单
    };
  },
  computed:{
    getMenu(){
      return this.$store.state.route.filter(route=>!['dongTool', '/bi'].includes(route.path) && route.path != '/bi_preview')
    },
    // 默认展开所有菜单
    openeds(){
      const routePath = this.$store.state.route
      const getPaths = (menuItem) => {
        let paths = [];
        menuItem.forEach(item => {
          paths.push(item.path)
          if(item.children){
            paths = paths.concat(getPaths(item.children));
          }
        });
        return paths;
      };
      return getPaths(routePath)
    },
    getIcon(){
      return (arr)=>{
        if(!arr||arr.length === 0){
          return false
        }
        const paths = arr.map(item=>item.jumpUrl)
        if(paths.includes(this.activeNow)){
          return true
        }else{
          return false
        }
      }
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    biInfos(){
      return this.$store.state.biInfo
    }
  },
  watch:{
    getMenu(){
      this.refresh(true)
    },
    // 路由切换更新菜单选中状态
    $route(val,old){
      if(old){
        this.refresh(true)
      }
    },
    activeNow(){
      const result = this.activeNow.split("/")[1]; 
      // 获取当前菜单的父菜单
      this.activeFirstMenu = `/${result}`; 
    }
  },
  methods: {
    handleBI(val,child) {
      if(child.jumpUrl === '/analysis/bi') {
        let jumpUrl = this.findJumpUrlInFirstItem(child.children[0]);
        jumpUrl = jumpUrl.replace("analysis/", "platform/")
        window.open(jumpUrl,'_blank')
        return
      }
    },
    // 更新菜单状态
    refresh(emit){
      this.getMenu.forEach(route=>{
        // 一级菜单
        const path = this.$route.path
        if(route.jumpUrl == path){
          this.activeNow = route.jumpUrl
          return emit && this.$emit('itemClick',[])
        }
        if(route.children && route.children.length){
          route.children.forEach(route2=>{
            if(route2.children && route2.children.length){
              route2.children.forEach(route3=>{
                if(route3.jumpUrl == path){
                  this.activeNow = route2.jumpUrl
                  emit && this.$emit('itemClick',route2.children,route2)
                }
              })
            }else if(route2.jumpUrl == path){
              this.activeNow = route2.jumpUrl
            }
          })
        }
      })
    },
    // 获取第一个bi菜单
    findJumpUrlInFirstItem(item) {
      if (!item) {
        return null;
      }
      if (item.children) {
        // 如果当前项有children，递归调用findJumpUrlInFirstItem
        return this.findJumpUrlInFirstItem(item.children[0]); // 只处理第一个子项
      } else if (item.jumpUrl) {
        // 如果当前项没有children但有jumpUrl，返回jumpUrl
        return item.jumpUrl;
      }
      // 如果当前项既没有children也没有jumpUrl，返回null
      return null;
    },
    routerpush(child) {
      console.log(child,'child');
      if(child.menuType == 'M' && (!child.children || child.children.length < 1)&&child.path!='yunqi_bi') {
        this.$message.warning("无对应权限，可联系您的专属业务帮您解决问题哦~");
        return;
      }
      // 重定向一级路由跳转
      if(child.jumpUrl === '/marketing/industry') {
        window.open('/industryStrategy','_blank')
        return
      }
      if(child.jumpUrl === '/marketing/industryPreview') {
        window.open('/industryPreview','_blank')
        return
      }
      // 云起BI跳转
      if(this.biInfos.type==1) {
        if(child.jumpUrl === '/analysis/bi'&&(this.biInfos.type==1||this.biInfos.type==3)) {
          let jumpUrl = this.findJumpUrlInFirstItem(child.children[0]);
          jumpUrl = jumpUrl.replace("analysis/", "platform/")
          console.log("jumpUrl",jumpUrl)
          window.open(jumpUrl,'_blank')
          return
        }
      } else if(this.biInfos.yqBiUrl&&child.path=='yunqi_bi'&&(this.biInfos.type==2||this.biInfos.type==3)) {
        window.open(this.biInfos.yqBiUrl,'_blank')
        return
      }
      if(child.path.includes('https') || child.path.includes('http')){
        window.open(child.path,'_blank')
        return
      }
      if(child.path == "export_management"&&this.$store.getters.loginUserInfo.platformFlag&&(this.softType!=2&&this.softType!=1)) {
        window.open(`${window.location.origin}/jd-yusms/yunzhou-common/system-redirect?redirectUrl=${encodeURIComponent(`/exportManagement?type=1&plat=jd&shopId=${this.$store.getters.loginUserInfo.venderId}`)}`, "_blank");
        return
      }
      if(child.path == "message_otification"&&this.$store.getters.loginUserInfo.platformFlag&&(this.softType!=2&&this.softType!=1)) {
        window.open(`${window.location.origin}/jd-yusms/yunzhou-common/system-redirect?redirectUrl=${encodeURIComponent(`/messageOtification?type=1&plat=jd&shopId=${this.$store.getters.loginUserInfo.venderId}`)}`, "_blank");
        return
      }
      if(child.children && child.children.length){
        this.$emit('itemClick',child.children,child)
      }else{
        this.$router.push(child.jumpUrl)
        this.$emit('itemClick',[])
      }
      this.activeNow = child.jumpUrl
    },
  }
};
</script>
<style lang="scss" scoped>
.section-left {
  // min-height: 844px;
  height: 100vh;
  overflow-x: hidden !important;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 0 8px 8px 0;
  text-align: left;
  height: 100%;
  overflow: auto;
  // margin-left: 12px;
  &__scroll{
    height: 100%;
  }
}
.title-wrap{
  font-family: PingFang SC;
  // font-family: system-ui, -apple-system, "Segoe UI", Roboto, Ubuntu, Cantarell, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", BlinkMacSystemFont, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "PingFang HK", "Microsoft Yahei", "Microsoft JhengHei";
  &-img{
    width:14px;
    height: 14px;
    margin-right: 7px;
  }
}
.textElse{
  font-family: PingFangSC Bold;
  color: #252525;
  font-weight: 600;
}
.textElse.act{
  color: #3159FF;
  font-weight: 600;
}
::v-deep{
  .el-menu{
    border-right: none;
    
  }
  .el-menu-item{
    padding-left: 16px!important;
    height: 42px;
    line-height: 42px;
  }
  .el-submenu__title{
    color: #333!important;
    font-weight: 400;
    padding-left: 16px!important;
    height: 42px;
    line-height: 42px;
    &:hover{
      background-color: #fff;
    }
  }
  .el-submenu .el-menu{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-left: 16px;
  }
  .el-submenu .el-menu-item{
    margin-bottom: 4px;
    padding: 0px !important;
    font-size: 14px;
    font-weight: 400;
    min-width: 90px;
    text-align: left;
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    // font-family: system-ui, -apple-system, "Segoe UI", Roboto, Ubuntu, Cantarell, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", BlinkMacSystemFont, "Helvetica Neue", Arial, "PingFang SC", "PingFang TC", "PingFang HK", "Microsoft Yahei", "Microsoft JhengHei";
    font-family: PingFang SC;
  }
  .el-scrollbar__wrap {
    padding-bottom: 8px;
  }
  .el-submenu .el-menu-item.is-active{
    // font-weight: 600!important;
  }
  .el-menu-item:hover, .el-menu-item:focus{
    background-color: transparent;
  }
  .el-menu-item.is-active{
    .textElse{
      font-weight: 600!important;
    }
  }
  .el-submenu.is-active{
    .title-wrap-text{
      font-weight: 600!important;
    }
  }
  .title-wrap-text{
    color: #252525;
     font-family: PingFangSC Bold;
    font-weight: 600!important;
  }
  .title-wrap-text.act{
    font-weight: 600!important;
    color: #3159FF;
  }
  .title-wrap-text.act{
    font-weight: 600!important;
    color: #3159FF;
  }
  .el-scrollbar__wrap{
    overflow-x: hidden;
  }
  .el-scrollbar__thumb{
    width:3px!important;
  }

  .nav-zhipu-tip {
    width: 28px;
    height: 12px;
    // background-image: url("https://yeion-public.s3.cn-north-1.jdcloud-oss.com/images/zhipu/tip_bg.png");
    background-image: url("../assets/homeDemo/zhipu.svg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top:-2px;
    right:10px;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 12px;
  }
  .nav-zhipu-tip1 {
    width: 28px;
    height: 12px;
    // background-image: url("https://yeion-public.s3.cn-north-1.jdcloud-oss.com/images/zhipu/tip_bg.png");
    background-image: url("../assets/homeDemo/xbj.svg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top:-2px;
    right:24px;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 12px;
  }
  .nav-zhipu-tip2 {
    width: 24px;
    height: 15px;
    background-image: url("../assets/homeDemo/free-icon.svg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: -4px;
    right: 3px;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 12px;
  }
  .nav-zhipu-tip3 {
    width: 28px;
    height: 12px;
    background-image: url("../assets/homeDemo/shopDecoration.svg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: -4px;
    right: 14px;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 12px;
  }
}
.jd-icon {
  position: absolute;
  top: 0;
  right: 15px;
  width: 28px;
  height: 12px;
}
.bi-icon {
  margin-right: 1px;
  width: 14px;
  height: 14px;
}
.personManager{
  height: 12px;
  position: absolute;
  top: -4px;
  right:18px;
}
.sub_title{
  height: 29px;
  padding: 0 8px;
  margin-left: -8px;
  border-radius: 6px;
  transition: all 0.2s;
  color: #565960;
  font-family: PingFangSC Regular;
  font-weight: 400;
  display: flex;
  align-items: center;
  &:hover{
    background-color: #F4F6FF;
    color: #3159FF;
  }
}
.sub_title.act{
  color: #3159FF;
  background-color: #F4F6FF;
}
.down-icon {
  font-size: 14px !important;
}
</style>
